const value = Object.freeze({
  I_II: 0,
  IIIa: 1,
  IIIb: 2,
  IV: 3,
  V: 4,
  VI: 5,
  VII: 6,
  Documents: 7,
});
export default value;
